import { atom } from 'nanostores';

export const HIDE_NAV_QUERY_PARAM = 'nonav';

// 'off' same as not passing param, 'default' removes nav from header and footer
const NO_NAV_PARAM_VALID_VALUES = ['default', 'all', 'off'];

export const $noNavParam = atom<string | null>(null);

export const loadNoNavParamFromSearchParamsOrStorage = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const noNavParamValue = urlSearchParams.get(HIDE_NAV_QUERY_PARAM);

  if (
    noNavParamValue !== null &&
    (noNavParamValue === '' || NO_NAV_PARAM_VALID_VALUES.includes(noNavParamValue))
  ) {
    $noNavParam.set(noNavParamValue || 'default');
    sessionStorage.setItem(HIDE_NAV_QUERY_PARAM, noNavParamValue || 'default');
  } else {
    const storedNoNavParam = sessionStorage.getItem(HIDE_NAV_QUERY_PARAM);
    if (storedNoNavParam) {
      $noNavParam.set(storedNoNavParam);
    }
  }
};
